import Vue from 'vue'
import VueRouter from 'vue-router'

import Autenticacion from "@/autenticacion/autenticacion";

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import('@/Index'),
    beforeEnter: Autenticacion,
    redirect: '/home',
    children: [
      {
        path: '/home',
        beforeEnter: Autenticacion,
        name: 'Home',
        component: () => import(/* webpackChunkName: "Home" */ '@/views/Home.vue')
      },
      {
        path: '/perfil',
        beforeEnter: Autenticacion,
        name: 'Perfil',
        component: () => import(/* webpackChunkName: "About" */ '@/views/usuario/Perfil.vue')
      },
      {
        path: '/about',
        beforeEnter: Autenticacion,
        name: 'About',
        component: () => import(/* webpackChunkName: "About" */ '@/views/About.vue')
      },
      {
        path: '/gestionactividades',
        beforeEnter: Autenticacion,
        name: 'GestionActividades',
        component: () => import(/* webpackChunkName: "GestionActividades" */ '@/views/aula/GestionActividades.vue')
      },
      {
        path: '/revisartareas',
        beforeEnter: Autenticacion,
        name: 'RevisarTareas',
        component: () => import(/* webpackChunkName: "RevisarTareas" */ '@/views/aula/RevisarTareas.vue')
      },
      {
        path: '/actividadesestudiante',
        beforeEnter: Autenticacion,
        name: 'ActividadesEstudiante',
        component: () => import(/* webpackChunkName: "ActividadesEstudiante" */ '@/views/aula/ActividadesEstudiante.vue')
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "Login" */ '@/views/ingreso/Login')
  },
  {
    path: "/error",
    component: () => import(/* webpackChunkName: "Error" */ '@/views/Error')
  },
  {
    path: "*",
    component: () => import(/* webpackChunkName: "Login" */ '@/views/noEncontrada')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
